import type { ComponentProps } from 'react';
import React from 'react';

import { cn } from '../cn';
import type { PlatformLinkProps } from '../contexts';
import { Arrows } from '../StrokeIcons';

export type BreadcrumbsProps = ComponentProps<'div'> & {
  showStartingChevron?: boolean;
};

export type BreadcrumbProps = ComponentProps<'div'> & {
  backwards?: boolean;
};

export type BreadcrumbLinkProps = PlatformLinkProps & {
  backwards?: boolean;
};

export default function Breadcrumbs({ children, showStartingChevron, className }: BreadcrumbsProps) {
  const filteredChildren = React.Children.map(children, (child, i) => {
    if (!React.isValidElement<BreadcrumbProps>(child)) return null;

    return (
      <>
        {(showStartingChevron || i > 0) && (
          <span className="size-4 text-[#d1d5de] *:h-full *:w-full">
            {child.props.backwards ? <Arrows.ChevronLeft /> : <Arrows.ChevronRight />}
          </span>
        )}
        {child}
      </>
    );
  })?.filter((a) => a);

  if (filteredChildren == null || filteredChildren.length <= 0) return null;
  return <div className={cn('flex min-w-0 items-center gap-2', className)}>{filteredChildren}</div>;
}
